import React from "react";
import TaskNameCardEmployee from "../../../plan/plan_contents/TaskNameCardEmployee";

// The employee's tasks for the day. Eligibility comes from the store roster,
// so this renders whether or not the person has a shift today.
export default function EmployeeTasksSection({ tasks, save_plan_task_assignment, homeCompany, roleNames, refreshOccurrences }) {
  if (!tasks?.length) return null;

  const groupedTasks = [];
  const intradayGroups = {};
  (tasks || []).forEach((task) => {
    if (task.intraday_slot_index != null && task.plan_task?.uuid) {
      const key = task.plan_task.uuid;
      if (!intradayGroups[key]) intradayGroups[key] = [];
      intradayGroups[key].push(task);
    } else {
      groupedTasks.push({ type: "single", task });
    }
  });
  Object.keys(intradayGroups).forEach((key) => {
    const slots = intradayGroups[key].sort(
      (a, b) => (a.intraday_slot_index || 0) - (b.intraday_slot_index || 0)
    );
    groupedTasks.push({ type: "intraday", slots, planTask: slots[0]?.plan_task });
  });

  return (
    <div className="w-full mt-3">
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Tasks</p>
      {groupedTasks.map((item, index) => {
        if (item.type === "single") {
          return (
            <div key={index} className="mt-1.5">
              <TaskNameCardEmployee
                task={item.task}
                save_plan_task_assignment={save_plan_task_assignment}
                refreshOccurrences={refreshOccurrences}
                homeCompany={homeCompany}
                roleNames={roleNames}
              />
            </div>
          );
        }
        // Submitted work waiting for a manager reads as "completed" in the
        // legacy status, so the lifecycle status decides when it is present.
        const slotsCompleted = item.slots.filter((s) =>
          s.lifecycle_status
            ? s.lifecycle_status === "completed"
            : s.status === "completed" || s.status === "completed_late"
        ).length;
        return (
          <div key={index} className="mt-1.5">
            <TaskNameCardEmployee
              task={item.slots[0]}
              intradaySlots={item.slots}
              intradaySlotsCompleted={slotsCompleted}
              intradayTotalSlots={item.slots.length}
              save_plan_task_assignment={save_plan_task_assignment}
              refreshOccurrences={refreshOccurrences}
              homeCompany={homeCompany}
              roleNames={roleNames}
            />
          </div>
        );
      })}
    </div>
  );
}
